import { formatBevaNumber, type BevaDetail } from '@repo/field-configs';

interface BevaEstimateBlockProps {
  readonly beva: string;
  readonly bevaDetail?: BevaDetail | null;
  readonly formatBevaValue?: () => string;
}

const thClass =
  'border border-gray-300 px-1 py-1 font-semibold text-center leading-tight break-words';
const tdClass = 'border border-gray-300 px-1 py-1 text-center leading-tight break-words';

/**
 * Compact BEVA estimate box + optional 2-row indices table for print HTML.
 * Table width is capped to the section content width (same as SectionHeader).
 */
export function BevaEstimateBlock({
  beva,
  bevaDetail,
  formatBevaValue,
}: BevaEstimateBlockProps) {
  const displayValue = formatBevaValue
    ? formatBevaValue()
    : beva && beva !== '—' && beva.trim()
      ? `${beva} €`
      : '—';

  return (
    <div className="flex flex-col items-stretch gap-1 w-full max-w-full overflow-hidden">
      <div className="text-xs sm:text-sm border border-gray-400 px-2 sm:px-3 py-1 self-start">
        <span className="font-bold text-sm sm:text-base lg:text-lg">Valeur estimée : </span>
        <span className="text-sm sm:text-base lg:text-lg">{displayValue}</span>
      </div>
      {bevaDetail ? (
        <div className="w-full max-w-full overflow-hidden">
          <table className="border border-gray-400 border-collapse text-xs sm:text-[13px] table-fixed w-full max-w-full">
            <thead>
              <tr className="bg-emerald-50">
                <th className={thClass} style={{ width: '7%' }}>
                  Numéro
                </th>
                <th className={thClass} style={{ width: '10%' }}>
                  Genre
                </th>
                <th className={thClass} style={{ width: '10%' }}>
                  Espèce
                </th>
                <th className={thClass} style={{ width: '14%' }}>
                  Nom vernaculaire
                </th>
                <th className={thClass} style={{ width: '10%' }}>
                  Indice espèce
                </th>
                <th className={thClass} style={{ width: '16%' }}>
                  Indice esthétique et sanitaire
                </th>
                <th className={thClass} style={{ width: '10%' }}>
                  Indice situation
                </th>
                <th className={thClass} style={{ width: '10%' }}>
                  Indice dimension
                </th>
                <th className={thClass} style={{ width: '13%' }}>
                  VALEUR B.E.V.A.
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={tdClass}>{bevaDetail.numero}</td>
                <td className={`${tdClass} italic`}>{bevaDetail.genre}</td>
                <td className={`${tdClass} italic`}>{bevaDetail.espece}</td>
                <td className={tdClass}>{bevaDetail.nomVernaculaire}</td>
                <td className={tdClass}>{formatBevaNumber(bevaDetail.varietyGrade)}</td>
                <td className={tdClass}>
                  {formatBevaNumber(bevaDetail.aestheticHealthIndex)}
                </td>
                <td className={tdClass}>{formatBevaNumber(bevaDetail.locationIndex)}</td>
                <td className={tdClass}>{formatBevaNumber(bevaDetail.sizeIndex)}</td>
                <td className={`${tdClass} font-bold`}>
                  {formatBevaNumber(bevaDetail.beva)} €
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
